// store/modules/pattern-generation.ts
import { GeneratePatternPlanMessage, GeneratePlanResponse } from '@/generated/websocketservice/model'
import PatternGenerationService from '@/services/PatternGenerationService'

interface PatternGenServiceState {
  response: GeneratePlanResponse | null
  isConnected: boolean
  error: string | null
}

export default {
  namespaced: true,
  state: (): PatternGenServiceState => ({
    response: null,
    isConnected: false,
    error: null
  }),
  mutations: {
    SET_RESPONSE (state: PatternGenServiceState, payload: GeneratePlanResponse) {
      state.response = payload
      if (state.response && state.response.status !== 'ok') {
        state.error = ('message' in state.response) ? state.response.message + ': ' + state.response.details!.join(' ') : state.response.status
      } else {
        state.error = null
      }
    },
    SET_CONNECTED (state: PatternGenServiceState, status: boolean) {
      state.isConnected = status
      if (status) {
        state.error = null
      }
    },
    SET_ERROR (state: PatternGenServiceState, error: string) {
      state.error = error
    }
  },
  actions: {
    connectPatternGeneration({commit}: {commit: any}, url: string) {
      PatternGenerationService.getInstance().connect(url, {
        onMessage: (response: GeneratePlanResponse) => commit ('SET_RESPONSE', response),
        onConnect: () => commit ('SET_CONNECTED', true),
        onDisconnect: () => commit ('SET_CONNECTED', false),
        onError: (e: string) => commit ('SET_ERROR', e)
      })
    },
    disconnectPatternGeneration() {
      PatternGenerationService.getInstance().disconnect()
    },
    sendRequest ({commit}: {commit: any}, payload: GeneratePatternPlanMessage) {
      try {
        PatternGenerationService.getInstance().sendMessage(payload)
      } catch (e) {
        commit('SET_ERROR', e.message)
      }
    }
  },
  getters: {
    patternGenResponse: (state: PatternGenServiceState) => state.response,
    isPatternGenConnected: (state: PatternGenServiceState) => state.isConnected,
    patternGenError: (state: PatternGenServiceState) => state.error
  }
}
